<section class="section">
  @if (loadingState.remaining > 0) {
    <loader [detailed]="true" [small]="true" [text]="loadingState.asText"></loader>
  }
  @for (aug of filteredSubscriptionsAugmented(); track aug.subscription.subscriptionId) {
    <div class="row">
      <div class="col-12">
        <network-service-element
          [subscription]="aug.subscription"
          [serviceDisruption]="aug.disruption"
          [health]="aug.health"
        ></network-service-element>
      </div>
    </div>
  }
</section>
